"use strict";
var appn;
(function (appn) {
    var tooltip;
    (function (tooltip) {
        let _selector;
        function init() {
            if (appn.isTestSuiteRequest)
                return;
            _selector = '[title]';
            dispose($(_selector));
            $(_selector).each(function () {
                $(this).tooltip({
                    animation: true,
                    container: 'body',
                    delay: {
                        show: 250,
                        hide: 100
                    },
                    html: true,
                    placement: $(this).attr('data-placement') || 'auto'
                });
            });
            addEvents();
        }
        tooltip.init = init;
        function addEvents() {
            $(_selector).on('show.bs.tooltip', function () {
            });
            $(_selector).on('shown.bs.tooltip', function () {
            });
            $(_selector).on('hide.bs.tooltip', function () {
            });
            $(_selector).on('hidden.bs.tooltip', function () {
            });
            $(_selector).on('inserted.bs.tooltip', function () {
            });
        }
        function show(element) {
            element.tooltip('show');
        }
        tooltip.show = show;
        function hide(element) {
            element.tooltip('hide');
        }
        tooltip.hide = hide;
        function toggle(element) {
            element.tooltip('toggle');
        }
        tooltip.toggle = toggle;
        function dispose(element) {
            element.tooltip('dispose');
        }
        tooltip.dispose = dispose;
        function enable(element) {
            element.tooltip('enable');
        }
        tooltip.enable = enable;
        function disable(element) {
            element.tooltip('disable');
        }
        tooltip.disable = disable;
        function toggleEnabled(element) {
            element.tooltip('toggleEnabled');
        }
        tooltip.toggleEnabled = toggleEnabled;
        function update(element) {
            element.tooltip('update');
        }
        tooltip.update = update;
    })(tooltip = appn.tooltip || (appn.tooltip = {}));
})(appn || (appn = {}));
